let toastFn;

export function setToastFn(fn) {
  toastFn = fn;
}

export function showToast(message, type = "success") {
  if (toastFn) {
    toastFn(message, type);
  } else {
    console.warn("Toast function not set yet!");
  }
}